<template>
  <div class="resource-library">
    <div class="resource-library__collapse-area">
      <button
        class="tb-btn tb-btn-text medium-em margin-bottom-xs ml-auto mr-auto block"
        data-entity="producer-expand-resourceLibrary"
        data-test="producer-assetLibrary-expandPanel"
        @click="$emit('expand')"
      >
        <span
          class="fas fa-angle-double-right"
          :class="{ 'fa-flip-horizontal': !collapsed }"
        />
      </button>

      <p class="resource-library__title">Libraries</p>
    </div>


    <div
      class="resource-library-body"
      :class="{
        'overflow-hidden': collapsed,
      }"
    >
      <div class="resource-library-body__title-bar">
        <div
          :class="{
            'source-types source-types--library': true,
            'small-viewport': elementTabOverflow,
          }"
          ref="libraryTabs"
          @scroll="handleScroll('libraryTabs', $event)"
        >
          <button
            v-if="libraryTabOverflow && showlibraryTabOverFlowButton[0]"
            class="btn btn-link btn-sm small-viewport__button-left"
            title="Scroll left"
            data-test="producer-assets-libraryTabs-scrollLeft"
            @click="scrollMenuLeft"
          >
            <span class="fas fa-angle-left" />
          </button>

          <button
            :class="{
              'btn btn-link btn-sm tab-btn--outlined': true,
              active: libraryTab === 'content',
            }"
            data-test="producer-assets-assetsTab"
            @click="libraryTab = 'content'"
          >
            Asset Library
          </button>

          <button
            :class="{
              'btn btn-link btn-sm tab-btn--outlined': true,
              active: libraryTab === 'design',
            }"
            data-test="producer-assets-designTab"
            @click="libraryTab = 'design'"
          >
            Design Library
          </button>

          <button
            v-if="libraryTabOverflow && showLibraryTabOverFlowButton[1]"
            class="btn btn-link btn-sm small-viewport__button-right"
            title="Scroll right"
            data-test="producer-assets-libraryTabs-scrollRight"
            @click="scrollMenuRight"
          >
            <span class="fas fa-angle-right" />
          </button>
        </div>

        <div class="resource-library-body__controls">
          <button
            class="btn btn-link btn-sm"
            title="Refresh asset library"
            data-entity="producer-assets-reloadAll"
            data-test="producer-assets-reloadAll"
            @click="reloadAssetLibrary"
          >
            <span class="fas fa-redo" />
          </button>
        </div>
      </div>

      <!-- Asset Library -->
      <keep-alive>
        <splitter
          v-if="libraryTab === 'content'"
          v-model="splitterHeights"
          class="h-full"
          vertical
        >
          <splitter-panel :min-height="40">
            <div class="flex-column resource-library-body__panel">
              <div class="header">
                <div class="header-section">
                  <button
                    class="tb-btn tb-btn-text sm medium-em margin-right-xs"
                    data-entity="producer-expand-timeline"
                    data-test="producer-displayElements-expand"
                    @click="collapsedElements = !collapsedElements"
                  >
                    <span
                      class="fas fa-angle-double-up"
                      :class="{ 'fa-flip-vertical': !collapsedElements }"
                    />
                  </button>
                  <p class="title margin-right-sm">Display Elements</p>
                </div>
              </div>
              <div class="source-types-wrapper">
                <div
                  class="source-types"
                  :class="{
                    'small-viewport': elementTabOverflow,
                  }"
                  ref="elementTabs"
                  @scroll="handleScroll('elementTabs', $event)"
                >
                  <button
                    v-if="elementTabOverflow && showElementTabOverFlowButton[0]"
                    class="btn btn-link btn-sm small-viewport__button-left"
                    title="Scroll left"
                    data-entity="producer-assets-scrollRight"
                    data-test="producer-assets-elementTabs-scrollLeft"
                    @click="scrollMenuLeft"
                  >
                    <span class="fas fa-angle-left" />
                  </button>

                  <button
                    :class="{
                      'btn btn-link btn-sm tab-btn--outlined': true,
                      active: elementTab === 'graphics',
                    }"
                    data-entity="producer-assets-showGraphics"
                    data-test="producer-assets-graphicsTab"
                    @click="elementTab = 'graphics'"
                  >
                    Graphics
                  </button>

                  <button
                    v-if="hasPanels && !hasNewPolls"
                    :class="{
                      'btn btn-link btn-sm tab-btn--outlined': true,
                      active: elementTab === 'interactive',
                    }"
                    data-entity="producer-assets-showPanels"
                    data-test="producer-assets-interactiveTab"
                    @click="elementTab = 'interactive'"
                  >
                    Interactive
                  </button>

                  <button
                    v-if="hasNewPolls"
                    :class="{
                      'btn btn-link btn-sm tab-btn--outlined': true,
                      active: elementTab === 'polls',
                    }"
                    data-entity="producer-assets-showPanels"
                    data-test="producer-assets-pollsTab"
                    @click="elementTab = 'polls'"
                  >
                    Polls
                  </button>

                  <button
                    :class="{
                      'btn btn-link btn-sm tab-btn--outlined': true,
                      active: elementTab === 'social displays',
                    }"
                    data-entity="producer-assets-showThemes"
                    data-test="producer-assets-displayTab"
                    @click="elementTab = 'social displays'"
                  >
                    Social Displays
                  </button>

                  <button
                    v-if="elementTabOverflow && showElementTabOverFlowButton[1]"
                    class="btn btn-link btn-sm small-viewport__button-right"
                    title="Scroll right"
                    data-entity="producer-assets-scrollRight"
                    data-test="producer-assets-elementTabs-scrollRight"
                    @click="scrollMenuRight"
                  >
                    <span class="fas fa-angle-right" />
                  </button>
                </div>
              </div>

              <div class="resource-library-body__list">
                <keep-alive>
                  <component
                    v-if="ready"
                    :is="elementTabComponent"
                    class="loaded"
                  />
                </keep-alive>
              </div>
            </div>
          </splitter-panel>
          <splitter-panel :min-height="40">
            <div class="flex-column resource-library-body__panel">
              <div class="header">
                <div class="header-section">
                  <button
                    class="tb-btn tb-btn-text sm medium-em margin-right-xs"
                    data-entity="producer-expand-timeline"
                    data-test="producer-curatedContent-expand"
                    @click="collapsedCurated = !collapsedCurated"
                  >
                    <span
                      class="fas fa-angle-double-up"
                      :class="{ 'fa-flip-vertical': collapsedCurated }"
                    />
                  </button>
                  <p class="title margin-right-sm">Curated Content</p>
                </div>
              </div>
              <div class="source-types-wrapper">
                <div
                  :class="{
                    'source-types': true,
                    'small-viewport': contentTabOverflow,
                  }"
                  ref="contentTabs"
                  @scroll="handleScroll('contentTabs', $event)"
                >
                  <button
                    v-if="contentTabOverflow && contentTabOverflowButtonsDisabled[0]"
                    class="btn btn-link btn-sm small-viewport__button-left"
                    title="Scroll left"
                    data-entity="producer-assets-scrollRight"
                    data-test="producer-assets-contentTabs-scrollLeft"
                    @click="scrollMenuLeft"
                  >
                    <span class="fas fa-angle-left" />
                  </button>

                  <button
                    :class="{
                      'btn btn-link btn-sm tab-btn--outlined': true,
                      active: contentTab === 'tagboards',
                    }"
                    data-entity="producer-assets-showTagboards"
                    data-test="producer-assets-boardsTab"
                    @click="contentTab = 'tagboards'"
                  >
                    Boards
                  </button>

                  <button
                    v-if="hasShoppable"
                    :class="{
                      'btn btn-link btn-sm tab-btn--outlined': true,
                      active: contentTab === 'shoppable',
                    }"
                    data-entity="producer-assets-showShoppable"
                    data-test="producer-assets-shoppableTab"
                    @click="contentTab = 'shoppable'"
                  >
                    Shoppable
                  </button>

                  <button
                    v-if="contentTabOverflow && contentTabOverflowButtonsDisabled[1]"
                    class="btn btn-link btn-sm small-viewport__button-right"
                    title="Scroll right"
                    data-entity="producer-assets-scrollRight"
                    data-test="producer-assets-contentTabs-scrollRight"
                    @click="scrollMenuRight"
                  >
                    <span class="fas fa-angle-right" />
                  </button>
                </div>
              </div>
              <div class="resource-library-body__list background-color-inherit">
                <keep-alive>
                  <component
                    v-if="ready"
                    :is="contentTabComponent"
                    :tagboard-id.sync="tagboardId"
                    class="loaded background-color-inherit"
                  />
                </keep-alive>
              </div>
            </div>
          </splitter-panel>
        </splitter>
      </keep-alive>

      <!-- Design Library -->
      <keep-alive>
        <design-library v-if="libraryTab === 'design'"/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import DesignLibrary from './DesignLibrary.vue';
import toast from '../../components/toast/toast';
import Splitter from '../../components/splitter/Splitter.vue';
import SplitterPanel from '../../components/splitter/SplitterPanel.vue';

export default {
  name: 'ResourceLibrary',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DesignLibrary,
    Splitter,
    SplitterPanel,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      ready: false, // Necessary to make sure state is cleaned up before children load data
      collapsedElements: false,
      collapsedCurated: false,
      splitterHeights: [50, 50],
      libraryTab: 'content',
      libraryTabOverflow: false,
      showLibraryTabOverflowButton: [false, false],
      elementTab: 'graphics',
      contentTab: 'tagboards',
      elementTabOverflow: false,
      showElementTabOverFlowButton: [false, false],
      contentTabOverflow: false,
      contentTabOverflowButtonsDisabled: [false, false],
      tagboardId: null,

      // TODO: Remove once flag is no longer needed
      hasNewPolls: this.$ld.has('new-polls-experience', false),
    };
  },

  computed: {
    ...mapState({
      panels: (state) => state.panels.panels,
      tagboards: (state) => state.tagboards.tagboards,
      templates: (state) => state.graphics.templates,
      themes: (state) => state.themes.themes,
    }),

    ...mapState('shoppable', [
      'selectedCollection',
    ]),
    ...mapGetters([
      'hasShoppable',
    ]),

    production() {
      return this.$store.state.production.production;
    },

    hasPanels() {
      return this.$store.state.user.hasPanels;
    },

    elementTabComponent() {
      switch (this.elementTab) {
        case 'graphics':
          return () => import('./Graphics.vue');
        case 'interactive':
          return () => import('./SmartPanels.vue');
        case 'social displays':
          return () => import('./Themes.vue');
        case 'polls':
          return () => import('./Polls/Tabs.vue');

        default:
          return () => import('./Graphics.vue');
      }
    },
    contentTabComponent() {
      switch (this.contentTab) {
        case 'tagboards':
          return () => import('./TagboardList.vue');
        case 'shoppable':
          return () => import('./Shoppable/Shoppable.vue');

        default:
          return () => import('./TagboardList.vue');
      }
    },
  },

  watch: {
    collapsedCurated() {
      this.handleCollapse();
    },
    collapsedElements() {
      this.handleCollapse();
    },
    splitterHeights(v) {
      localStorage.producerLibrarySizes = JSON.stringify(v);
    },
  },

  mounted() {
    if (localStorage.producerLibrarySizes) {
      this.splitterHeights = JSON.parse(localStorage.producerLibrarySizes);
    }

    this.handleTabOverflow(true, true);

    window.addEventListener('resize', this.handleResize);

    // If assets were already loaded before, then let's reset everything to empty.
    // This not only ensures assets to up-to-date,
    // but makes sure state is cleared if user is bouncing between teams.
    const hasAssets = (
      this.themes.length
      || this.templates.length
      || this.panels.length
      || this.tagboards.length
    );

    if (hasAssets) {
      this.resetAssetLibrary();
    }

    this.ready = true;
  },

  created() {
    this.$ld.on(this.onChangeFlags); // TODO: Remove
  },

  beforeDestroy() {
    this.$ld.off(this.onChangeFlags); // TODO: Remove
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    ...mapActions([
      'getGraphics',
      'resetTemplates',
      'getTemplates',
      'getGraphicsTags',
      'resetThemes',
      'getThemes',
      'getSocialDisplayTags',
      'resetPanels',
      'getPanels',
      'getInteractiveTags',
      'resetTagboards',
      'clearTagboardPosts',
      'getPostsByTagboard',
      'getTagboardTags',
    ]),
    ...mapActions('shoppable', [
      'getProducts',
      'getCollections',
    ]),
    ...mapActions('polls', [
      'getPolls',
      'getPollTags',
      'resetPolls',
    ]),

    onChangeFlags() {
      this.hasNewPolls = this.$ld.has('new-polls-experience', false);
    },

    /**
    * Reset state for all assets to empty (and page back to 1).
    */
    resetAssetLibrary() {
      if (this.libraryTab === 'content') {
        this.$store.dispatch('resetTemplates');
        this.$store.dispatch('resetThemes');
        this.$store.dispatch('resetPanels');
        this.$store.dispatch('resetTagboards');
        this.resetPolls();

        // Reset currently active tagboard if it's open
        if (this.tagboardId) {
          this.$store.dispatch('clearTagboardPosts', this.tagboardId);
        }
      } else if (this.libraryTab === 'design') {
        this.$store.dispatch('assets/resetAssets');
      }
    },

    /**
    * Reload loaded assets for all tabs.
    * We might want to limit this to the active tab in the future.
    */
    async reloadAssetLibrary() {
      try {
        // First we want to clear the current state and ensure `page` is set back to one.
        this.resetAssetLibrary();

        if (this.libraryTab === 'content') {
          // Then, we'll refetch EVERYTHING
          await Promise.all([
            this.$store.dispatch('getTemplates'),
            this.getGraphicsTags(),
            this.$store.dispatch('getThemes'),
            this.getSocialDisplayTags(),
            this.$store.dispatch('getPanels'),
            this.getInteractiveTags(),
            this.$store.dispatch('getTagboards'),
            this.getTagboardTags(),
            this.getPolls(),
            this.getPollTags(),
            (this.selectedCollection && this.selectedCollection > 0) ? this.getProducts({ reset: true, collectionId: this.selectedCollection }) : this.getCollections({ reset: true }),
            this.tagboardId ? this.$store.dispatch('getPostsByTagboard', { tagboardId: this.tagboardId }) : null,
          ]);
        } else if (this.libraryTab === 'design') {
          await this.$store.dispatch('assets/getAssets');
        }

      } catch (err) {
        console.error('Failed to reload asset library:', err);

        toast.makeToast({
          heading: 'Error',
          icon: 'error',
          loaderBg: 'red',
          text: 'Error reloading asset library. Some or all assets might not have loaded properly.',
        });
      }
    },

    scrollMenuLeft(e) {
      const menuContainer = e.target.closest('.source-types');
      menuContainer.scrollLeft -= 150; // Adjust this value as needed
    },

    scrollMenuRight(e) {
      const menuContainer = e.target.closest('.source-types');
      menuContainer.scrollLeft += 150; // Adjust this value as needed
    },

    handleScroll(el, event) {
      this.handleTabOverflow(el === 'elementTabs', el === 'contentTabs', el === 'libraryTabs');
    },

    handleTabOverflow(checkElTabs = false, checkContentTabs = false, checkLibraryTabs = false) {
      const { elementTabs, contentTabs, libraryTabs } = this.$refs;

      if (checkLibraryTabs && libraryTabs) {
        this.libraryTabOverflow = libraryTabs.scrollWidth > libraryTabs.clientWidth;
        this.showLibraryTabOverFlowButton = [
          libraryTabs.scrollLeft !== 0,
          libraryTabs.scrollLeft < libraryTabs.scrollWidth - libraryTabs.clientWidth,
        ];
      }

      if (checkElTabs && elementTabs) {
        this.elementTabOverflow = elementTabs.scrollWidth > elementTabs.clientWidth;
        this.showElementTabOverFlowButton = [
          elementTabs.scrollLeft !== 0,
          elementTabs.scrollLeft < elementTabs.scrollWidth - elementTabs.clientWidth,
        ];
      }

      if (checkContentTabs && contentTabs) {
        this.contentTabOverflow = contentTabs.scrollWidth > contentTabs.clientWidth;
        this.contentTabOverflowButtonsDisabled = [
          contentTabs.scrollLeft !== 0,
          contentTabs.scrollLeft < contentTabs.scrollWidth - contentTabs.clientWidth,
        ];
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      this.handleScroll({ target: this.$el.querySelector('.source-types') });
    },

    handleCollapse() {
      if (this.collapsedElements && this.collapsedCurated) {
        this.splitterHeights = [50, 50];
      } else if (this.collapsedCurated) {
        this.splitterHeights = [0, 100];
      } else if (this.collapsedElements) {
        this.splitterHeights = [100, 0];
      } else {
        this.splitterHeights = [50, 50];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.source-types-wrapper {
  min-height: 0;
  position: relative;
  background: #222222;
}

.small-viewport {
  overflow-x: auto;
  scrollbar-width: none;
  overscroll-behavior: contain auto;

  span:first-child {
    padding-left: 12px;
  }

  span{
    padding-left: 8px;
    padding-right: 8px;
  }

  &__button-right, &__button-left {
    position: absolute;
    line-height: 40px;
    padding: 0 10px;
    border: none;
    border-radius: 0;

    &:focus {
      outline: none;
    }

    span {
      border-bottom: none;
    }
  }

  &__button-right {
    right: 0;
    background: linear-gradient(-90deg, #1e1e1e 75%, transparent);
  }
  &__button-left {
    left: 0;
    background: linear-gradient(-90deg, transparent, #1e1e1e 25%);
  }
}
</style>
